/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SENSYN ID API
 * - ユーザー、組織情報の取得API
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CustomAllAppsResponse,
  CustomTextResponse,
  GetCustomAllAppsParams,
  GetCustomTextsParams,
  GetOwnOrganizationParams,
  OrganizationResponse,
  OrganizationsResponse
} from '../model';

import getAllOrganizationsMutator from '../../../mutators/sensyn-id-instance';
import getOwnOrganizationMutator from '../../../mutators/sensyn-id-instance';
import getCustomTextsMutator from '../../../mutators/sensyn-id-instance';
import getCustomAllAppsMutator from '../../../mutators/sensyn-id-instance';



  /**
 * - 全ての組織情報を取得する
 * @summary getAllOrganizations
 */
export const getAllOrganizations = (

 ) => {
      return getAllOrganizationsMutator<OrganizationsResponse>(
      {url: `/organizations/`, method: 'GET'
    },
      );
    }
  /**
 * - ログインユーザーの組織情報を取得する
 * @summary getOwnOrganization
 */
export const getOwnOrganization = (
    params?: GetOwnOrganizationParams,
 ) => {
      return getOwnOrganizationMutator<OrganizationResponse>(
      {url: `/organization/`, method: 'GET',
        params
    },
      );
    }
  /**
 * - 組織の指定アプリ権限のカスタムテキストを取得する
 * @summary getCustomTexts
 */
export const getCustomTexts = (
    params: GetCustomTextsParams,
 ) => {
      return getCustomTextsMutator<CustomTextResponse>(
      {url: `/organization/custom-texts/`, method: 'GET',
        params
    },
      );
    }
  /**
 * - 組織のカスタムアプリ名を全て取得する
 * @summary getCustomAllApps
 */
export const getCustomAllApps = (
    params: GetCustomAllAppsParams,
 ) => {
      return getCustomAllAppsMutator<CustomAllAppsResponse>(
      {url: `/organization/custom-texts/all-apps/`, method: 'GET',
        params
    },
      );
    }
  export type GetAllOrganizationsResult = NonNullable<Awaited<ReturnType<typeof getAllOrganizations>>>
export type GetOwnOrganizationResult = NonNullable<Awaited<ReturnType<typeof getOwnOrganization>>>
export type GetCustomTextsResult = NonNullable<Awaited<ReturnType<typeof getCustomTexts>>>
export type GetCustomAllAppsResult = NonNullable<Awaited<ReturnType<typeof getCustomAllApps>>>
